import React from 'react';

// The campus photo on a college page (founder, 2026-09-30). Self-hosted WebP
// at two widths with explicit dimensions (no layout shift), loaded eagerly
// with high priority because it is the page's largest paint. The credit is
// the license's requirement: author, license, and the Commons file page.
// 1200w for high-density phones (#2605): 800w is too small at 2.6x and
// 1600w costs LCP on a phone connection.
export const photoSrcSet = (p) => [`${p.srcSmall} 800w`, p.srcMid && `${p.srcMid} 1200w`, `${p.src} 1600w`].filter(Boolean).join(', ');
export const PHOTO_SIZES = '(min-width: 1024px) 976px, calc(100vw - 32px)';

export default function CampusPhoto({ photo, className = '' }) {
    return (
        <figure className={`${className ? `${className} ` : ''}mt-5`}>
            <img
                src={photo.src}
                srcSet={photoSrcSet(photo)}
                sizes={PHOTO_SIZES}
                width={photo.width}
                height={photo.height}
                alt={photo.alt}
                fetchPriority="high"
                decoding="async"
                className="h-auto w-full rounded-2xl border border-[#E0DED8] bg-[#E8E5DC] object-cover lg:aspect-[21/9]"
            />
            <figcaption className="mt-1.5 text-xs text-[#6B6B6B]">
                Photo:{' '}
                <a href={photo.sourceUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">
                    {photo.title}
                    <span className="sr-only"> (opens in a new tab)</span>
                </a>
                {' '}by {photo.author},{' '}
                {photo.licenseUrl ? (
                    <a href={photo.licenseUrl} target="_blank" rel="noopener noreferrer license" className="underline underline-offset-2">
                        {photo.license}
                        <span className="sr-only"> (opens in a new tab)</span>
                    </a>
                ) : photo.license}
                , via Wikimedia Commons. Cropped and resized{/sa/i.test(photo.license) ? ', shared under the same license' : ''}.
            </figcaption>
        </figure>
    );
}
